import { defineBoot } from '#q-app';
import { Router } from 'vue-router';

let globalRouter: Router;

export default defineBoot(({ app, router }) => {
  app.config.globalProperties.$router = router;
  globalRouter = router;
});

export { globalRouter };
